import { useEffect } from "react";

/**
 * Closes a popover (menu, listbox, date picker) on Escape or on a press
 * outside `ref`. Listens only while `open`.
 */
export function useDismiss(ref, open, onClose) {
  useEffect(() => {
    if (!open) return undefined;
    const onDown = (e) => !ref.current?.contains(e.target) && onClose();
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("pointerdown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [ref, open, onClose]);
}

/** The surface every popover draws on. */
export const popoverClass = "z-40 rounded-card border border-line bg-surface-raised text-ink shadow-pop animate-pop-in";
